module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Arrow_down_Light Blue.d45f3dd4.svg";